import { h } from 'preact'
import { Message } from '../../../../lib/intl/Message'
import { InfoHeading } from './shared'
import { Geografi, isGeografi } from '../../../domain'
import { useAppState } from '../../../../lib/redux-provider-nohooks'
import { idFrom } from '../../../api'

type Props = {
  geografi: Geografi
}

const IKKE_SAMMENLIGNBARE_KOMMUNER = [
  '5055', // Heim
  '5056', // Hitra
  '5059', // Orkland
  '1806', // Narvik
  '1875' // Hammarøy
]

const TIDLIGERE_SAMMENSLATTE_KOMMUNER = [
  '3804', // Sandefjord
  '3805', // Larvik
  '3802', // Holmestrand
  '3811', // Færder
  '5054' // Indre Fosen
]

const TIDLIGERE_SAMMENSLATTE_FYLKER = [
  '50' // Trøndelag
]

const FLERTALL_FYLKER = ['54', '38']

export function SammenslaingsInfo({ geografi }: Props) {
  const { sammenslattAv } = geografi

  if (sammenslattAv && sammenslattAv.length) {
    if (geografi.type === 'Fylke') {
      if (TIDLIGERE_SAMMENSLATTE_FYLKER.indexOf(idFrom(geografi)) !== -1) {
        return null
      }

      return (
        <section>
          <InfoHeading id="info-nytt-fylke-tittel" />
          {FLERTALL_FYLKER.indexOf(idFrom(geografi)) !== -1 ? (
            <Message
              id="info-nytt-fylke-beskrivelse-flertall"
              values={{
                tidligere: sammenslattAv,
                ny: geografi.navn
              }}
            />
          ) : (
            <Message
              id="info-nytt-fylke-beskrivelse-entall"
              values={{
                tidligere: sammenslattAv,
                ny: geografi.navn
              }}
            />
          )}
        </section>
      )
    } else {
      if (TIDLIGERE_SAMMENSLATTE_KOMMUNER.indexOf(idFrom(geografi)) !== -1) {
        return null
      }

      return (
        <section>
          <InfoHeading id="info-ny-kommune-tittel" />
          <Message
            id="info-ny-kommune-beskrivelse"
            values={{
              tidligere: sammenslattAv,
              ny: geografi.navn
            }}
            modifiers={{
              'ikke-sammenlignbar': IKKE_SAMMENLIGNBARE_KOMMUNER.indexOf(idFrom(geografi)) !== -1
            }}
          />
        </section>
      )
    }
  }

  return null
}

export function ConnectedSammenslaingsInfo() {
  const { page } = useAppState()
  const currentPage = page.current

  if (!isGeografi(currentPage)) {
    return null
  }

  return <SammenslaingsInfo geografi={currentPage} />
}
